import navbarSearchAndPinList from '@/containers/components/navbarSearchAndPinList'
import {themeConfig, colors} from '../../themeConfig.js'

export const state = {
    isSidebarActive: true,
    breakpoint: null,
    sidebarWidth: "default",
    reduceButton: themeConfig.sidebarCollapsed,
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: themeConfig.theme || 'light',
    navbarSearchAndPinList: navbarSearchAndPinList,
    currentUser: {
        id_pessoa: 0,
        nome: '',
        foto: null,
        usuario_cargo: 0,
    },
    authToken: null,
    themePrimaryColor: colors.primary,
    daterange: {
        startDate: new Date(),
        endDate: new Date(),
    },
    usuarios: [],
    axios_req: {},
};
